import { useEffect, useState } from "react";
import { useI18n } from "@/context/LanguageContext";

const calc = (target) => {
  const diff = Date.now() - target.getTime();
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0, done: false };
  return {
    d: Math.floor(diff / 86400000),
    h: Math.floor((diff / 3600000) % 24),
    m: Math.floor((diff / 60000) % 60),
    s: Math.floor((diff / 1000) % 60),
    done: true,
  };
};

export const Countdown = ({ date }) => {
  const { t } = useI18n();
  const [tm, setTm] = useState(() => calc(date));
  useEffect(() => {
    const id = setInterval(() => setTm(calc(date)), 1000);
    return () => clearInterval(id);
  }, [date]);

  const items = [
    { label: t.countdown.days, value: tm.d, key: "dies" },
    { label: t.countdown.hours, value: tm.h, key: "hores" },
    { label: t.countdown.minutes, value: tm.m, key: "minuts" },
    { label: t.countdown.seconds, value: tm.s, key: "segons" },
  ];

  return (
    <section data-testid="countdown-section" className="bg-[#F46555] text-[#141518] py-12 md:py-16 border-y-2 border-[#141518]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <div className="font-condensed font-bold uppercase tracking-[0.25em] text-sm md:text-base text-[#141518]">{t.countdown.eyebrow}</div>
            <h3 className="font-display font-bold text-3xl md:text-4xl mt-2 text-[#141518]">{t.countdown.title}</h3>
          </div>
          <div className="grid grid-cols-4 gap-2 md:gap-6 w-full md:w-auto" data-testid="countdown-grid">
            {items.map((it) => (
              <div key={it.key} className="text-center bg-white border-2 border-[#141518] shadow-hard-sm px-2 py-3 md:px-6 md:py-4 min-w-0 md:min-w-[100px]" data-testid={`countdown-${it.key}`}>
                <div className="font-display font-bold text-2xl sm:text-3xl md:text-5xl tabular-nums text-[#141518]">{String(it.value).padStart(2, "0")}</div>
                <div className="font-condensed uppercase text-[9px] md:text-[10px] tracking-[0.25em] text-[#141518]/70 mt-1">{it.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
